module.exports = function getResource(label, vars = []) {
    let resources = {
        seeAllFoundations: 'Découvrir tous les fonds de teint',
        matchFound: 'Votre teinte correspondante.',
        noMatches: 'Désolés, aucune correspondance trouvée.'
    };
    return resources[label];
};
